import { createContext, useContextSelector } from '@fluentui/react-context-selector';
export const TeachingPopoverContext = createContext(undefined);
const teachingPopoverContextDefaultValue = {
    currentPage: 0,
    setCurrentPage: ()=>null,
    totalPages: 1,
    setTotalPages: ()=>null,
    appearance: undefined,
    onPageChange: ()=>null,
    onFinish: ()=>null
};
export const TeachingPopoverProvider = TeachingPopoverContext.Provider;
export const useTeachingPopoverContext_unstable = (selector)=>useContextSelector(TeachingPopoverContext, (ctx = teachingPopoverContextDefaultValue)=>selector(ctx));
